import { ShiftRequest } from '@app/core/async-services/http/versioned/interfaces/scheduler.interface';

export interface ShiftSwapState {
  data: ShiftRequest[] | null;
  ui: {
    isShiftRequestsLoaded: boolean;
    menu?: {
      entId: string;
      fromDate: string;
      toDate: string;
    };
  };
}

export const initialState: ShiftSwapState = {
  data: null,
  ui: {
    isShiftRequestsLoaded: false,
  },
};
